import React from 'react';
import { Box, Button, CircularProgress, Grid, Typography } from '@mui/material';
import PageHeader from 'app/components/PageHeader';
import { btnStatusPayment, accordionBox, statusPayment } from './AccountsCardsPage.sx';
import useAccountCardsPage from './useAccountCardsPage';
import AccordionCustom from 'app/components/AccordionCustom';
import AccountDetails from 'app/components/AccordionCustom/AccountDetails';
import CardDetails from 'app/components/AccordionCustom/CardDetails';
import logger from 'app/utils/logger';
import { grayDefault, grayFilter } from 'app/components/ThemeProvider/colors';
import PhoneVerifyModal from 'app/components/PhoneVerifyModal';
import InstantPaymentsSignUp from './InstantPaymentsSignUp';
import PlusIcon from 'app/components/Icons/PlusIcon';
import AliasAddModal from 'app/components/AliasAddModal';
import AliasCard from './AliasCard';
import AccountsAddModal from 'app/pages/AccountsCardsPage/AccountAddModal';

const AccountsCardsPage = () => {
  const {
    filterBtns,
    statusFilterBtns,
    btnId,
    account,
    accountOnChange,
    statusBtnId,
    setStatusBtnId,
    handleChangePageType,
    pageType,
    cardOnChange,
    card,
    isLoadingGetDataAccount,
    dataGetAccount,
    isLoadingGetDataCard,
    accountData,
    setAccountData,
    cardData,
    smsNotif,
    handleSwitchSMS,
    handleCardStatus,
    aliasAddModal,
    setAliasAddModal,
    aliasValue,
    accountsModal,
    setAccountsModal,
    setCardData,
    dataGetCard,
    blockCard,
    handleSwitchBlock,
  } = useAccountCardsPage();

  if (isLoadingGetDataAccount || isLoadingGetDataCard) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
          height: '100%',
        }}
      >
        <CircularProgress />
      </Box>
    );
  } else {
    return (
      <Box>
        <PageHeader pageName={'Hesablar və kartlar'} />
        <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', gap: '31px', flexDirection: 'column', width: '100%' }}>
            <Box sx={{ display: 'flex', gap: '16px', minWidth: '335px' }}>
              {filterBtns.map((item, index) => (
                <Button
                  key={item.id}
                  color={'tertiary'}
                  size={'medium'}
                  sx={
                    btnId === item.id
                      ? { ...btnStatusPayment, background: grayFilter, boxShadow: '2px 2px 32px rgba(0, 0, 0, 0.06)' }
                      : btnStatusPayment
                  }
                  onClick={() => {
                    setStatusBtnId(1);
                    handleChangePageType(item.id);
                  }}
                >
                  {item.title}
                  {/*{item.count && (*/}
                  {/*  <Box sx={notif}>*/}
                  {/*    <Typography sx={notifText}>{item.count}</Typography>*/}
                  {/*  </Box>*/}
                  {/*)}*/}
                </Button>
              ))}
            </Box>
            {pageType !== 'instant-payments-sign-up' && (
              <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <Box sx={{ display: 'flex', gap: '8px' }}>
                  {statusFilterBtns
                    .filter((item, idx) => {
                      if (pageType === 'instant-payments') {
                        if (item.id !== 2 && item.id !== 3) {
                          return true;
                        }
                      } else {
                        if (item.id < 4) {
                          return true;
                        }
                      }
                    })
                    .map((item, index) => (
                      <Button
                        key={item.id}
                        color={statusBtnId === item.id ? 'info' : 'tertiary'}
                        sx={
                          statusBtnId === item.id
                            ? {
                                ...statusPayment(item.id),
                              }
                            : {
                                ...btnStatusPayment,
                                background: 'transparent',
                                border: 1,
                                height: '32px',
                                borderRadius: '20px',
                                borderWidth: '2px',
                                borderColor: grayDefault,
                              }
                        }
                        onClick={() => {
                          setStatusBtnId(item.id);
                          if (item.id === 1) {
                            setAccountData(dataGetAccount?.accounts);
                            setCardData(dataGetCard?.accounts);
                          } else if (item.id === 2) {
                            setAccountData(dataGetAccount?.accounts.filter((status: any) => status.state === 'OPEN'));
                            setCardData(dataGetCard?.accounts.filter((status: any) => status.state === 'ACTIVE'));
                          } else if (item.id === 3) {
                            setAccountData(
                              dataGetAccount?.accounts.filter((status: any) => status.state === 'BLOCKED')
                            );
                            setCardData(
                              dataGetCard?.accounts.filter(
                                (status: any) => status.state === 'BLOCKED' || status.state === 'BANKBLOCKED'
                              )
                            );
                          }
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: '14px',
                            fontWeight: '500',
                            lineHeight: '20px',
                            color: statusBtnId === item.id && 'white',
                          }}
                        >
                          {item.title}
                        </Typography>
                      </Button>
                    ))}
                </Box>
                {(statusBtnId === 5 || statusBtnId === 6) && (
                  <Button
                    color={'secondary'}
                    onClick={() => {
                      setAliasAddModal(true);
                    }}
                  >
                    <PlusIcon color={'info'} />
                    Alias əlavə et
                  </Button>
                )}
              </Box>
            )}
          </Box>
        </Box>
        <Box sx={accordionBox}>
          {pageType === 'accounts' &&
            accountData?.length > 0 &&
            accountData?.map((item: any, index: any) => (
              <AccordionCustom
                key={index}
                pageName={'accounts'}
                headerText={item.product_name}
                accountText={item?.iban}
                amount={item.main_balance}
                status={item.state}
                currency={item.currency}
                detailsAccordion={
                  <AccountDetails
                    accountOptions={account}
                    accountValue={{
                      balance: item?.main_balance,
                      iban: item?.iban,
                      currency: item?.currency,
                      blocked: item?.blocked_balance,
                      taxOrder: item?.have_tax_order,
                      value: item?.iban,
                      label: `${item?.product_name} (${item?.iban})`,
                      govAmount: item?.goverment_amount,
                    }}
                    accountsList={accountData}
                    accountOnChange={accountOnChange}
                  />
                }
              />
            ))}
          {pageType === 'cards' && (
            <>
              {cardData?.length > 0
                ? cardData?.map((item: any, index: any) => (
                    <AccordionCustom
                      key={index}
                      pageName={'cards'}
                      headerText={item.product_name}
                      accountText={item.iban}
                      amount={item.main_balance}
                      status={item.state}
                      currency={item.currency}
                      img={item.icon}
                      detailsAccordion={
                        <CardDetails
                          cardOptions={card}
                          cardValue={{
                            balance: item.main_balance,
                            iban: item?.iban,
                            cardNum: item.card_no,
                            expDate: item?.expire_date ? `${item?.expire_date?.slice(0, 2)}/${item?.expire_date?.slice(
                              2
                            )}` : '' ,
                            currency: item.currency,
                            taxOrder: item.have_tax_order,
                            value: item?.iban,
                            label: `${item.product_name} (${item?.iban})`,
                            govAmount: item?.goverment_amount,
                            blocked: item.blocked_balance,
                          }}
                          cardsList={cardData}
                          cardOnChange={cardOnChange}
                          status={item.state}
                          smsNotif={smsNotif[index] === '1'}
                          blockCard={blockCard[index] !== 'ACTIVE'}
                          handleSwitch={handleSwitchSMS}
                          index={index}
                          handleCardStatus={handleSwitchBlock}
                        />
                      }
                    />
                  ))
                : null}
              {/*<Button onClick={handleCardOrder} sx={cardOrderBtn}>*/}
              {/*  <IncomingPlus color={'secondary'} />*/}
              {/*  <Typography sx={{ fontSize: '17px', fontWeight: 600 }}>Yeni kart sifariş et</Typography>*/}
              {/*</Button>*/}
            </>
          )}
          {pageType === 'instant-payments-sign-up' && <InstantPaymentsSignUp />}
          {pageType === 'instant-payments' && (
            <Box sx={{ display: 'flex', gap: '16px', flexDirection: 'column' }}>
              {(statusBtnId === 4 || statusBtnId === 1) && (
                <>
                  <AliasCard
                    accountsModal={accountsModal}
                    setAccountsModal={setAccountsModal}
                    headerText={'1401748081'}
                    type={'VÖEN'}
                  />
                </>
              )}
              {(statusBtnId === 5 || statusBtnId === 1) && (
                <>
                  <AliasCard
                    accountsModal={accountsModal}
                    setAccountsModal={setAccountsModal}
                    headerText={'+994552019226'}
                    type={'Mobil'}
                  />
                </>
              )}
              {(statusBtnId === 6 || statusBtnId === 1) && (
                <>
                  <AliasCard
                    accountsModal={accountsModal}
                    setAccountsModal={setAccountsModal}
                    headerText={'msuleymanov@yelo.az'}
                    type={'Elektron poçt'}
                  />
                  <AliasCard
                    accountsModal={accountsModal}
                    setAccountsModal={setAccountsModal}
                    headerText={'turgaygasimli@yelo.az'}
                    type={'Elektron poçt'}
                  />
                </>
              )}
            </Box>
          )}
          <AliasAddModal
            accountsModal={accountsModal}
            setAccountsModal={setAccountsModal}
            handleSubmit={() => {}}
            open={aliasAddModal}
            close={setAliasAddModal}
            inputTitle={'Mobil Nomre'}
            value={aliasValue}
            type={statusBtnId === 5 ? 'mobile' : 'email'}
          />
          <AccountsAddModal accountData={accountData} open={accountsModal} close={setAccountsModal} />
        </Box>
      </Box>
    );
  }
};

export default AccountsCardsPage;
